module.exports = __webpack_public_path__ + "img/zhAward-b.9918da85.png";